module.exports = ".kan-main-container {\n  position: absolute;\n  top: 60px;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n  .kan-main-container .kan-main-sidenav {\n    width: 250px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/main/component.scss
// module id = ./src/modules/main/components/main/component.scss
// module chunks = main